export const formatVersionNumber = (value: number): string => {
  if (!Number.isFinite(value)) {
    return String(value);
  }

  return Number.isInteger(value) ? `${value}.0` : String(value);
};
